import { BoothDesignMasterElement } from 'models';

// eslint-disable-next-line import/prefer-default-export
export const elementToBoundingBox = ({
  positionX, positionY, width, height,
}: BoothDesignMasterElement) => ({
  a: { x: positionX.dimension - width.dimension / 2, y: positionY.dimension - height.dimension / 2 },
  b: { x: positionX.dimension + width.dimension / 2, y: positionY.dimension + height.dimension / 2 },
});
